









import Enumerable from "linq";
import { SortOrder } from "element-ui/types/table";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { Comparator } from "../../../../base/domain/system";
import { ISortParameter } from "../../../../base/components/system";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../base/components/system/selectors";
import { StandardOption } from "../../../../base/components/system/selectors/mixins";

interface IFormatsColumn {
  name: string;
  toValue: ToValueType;
}

type ToValueType = (s: EditableFormatSummary) => number | boolean | string | Date;

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class FormatSortSelector extends Mixins(ModelEditableMixin) {
  @Prop()
  formats: EditableFormatSummary[];

  @Prop()
  sortParameter: ISortParameter;

  private static readonly _columns: { [key: string]: IFormatsColumn; } = {
    id: { name: "ID", toValue: s => s.id },
    name: { name: "フォーマット名称", toValue: s => s.name },
    edition: { name: "版", toValue: s => s.edition },
    status: { name: "状態", toValue: s => s.isTemporary },
    lastUpdateDateTime: { name: "最終更新日時", toValue: s => s.lastUpdateDateTime },
    sort: { name: "表示順", toValue: s => s.sort },
  };

  get sortTypeOptions(): StandardOption<IFormatsColumn>[] {
    return Enumerable.from(Object.keys(FormatSortSelector._columns)) // Object.valuesはIE非対応っぽい.
      .select(k => FormatSortSelector._columns[k])
      .select(c => new StandardOption<IFormatsColumn>(this.replaceWording(c.name), c))
      .toArray();
  }

  get defaultSortType(): IFormatsColumn {
    return FormatSortSelector._columns.sort;
  }

  get defaultOrderType(): SortOrder {
    return "ascending";
  }

  get isSortSettingEnable(): boolean {
    // TODO: コンフィグ追加する
    // return this.$configuration.behavior.document.list.sort.default.isEnable;
    return false;
  }

  get settingSortType(): IFormatsColumn {
    // TODO: コンフィグ追加する
    // return FormatSortSelector._columns[this.$configuration.behavior.document.list.sort.default.columnKey] as IFormatsColumn;
    return FormatSortSelector._columns.sort;
  }

  get settingOrderType(): SortOrder {
    // TODO: コンフィグ追加する
    // return this.$configuration.behavior.document.list.sort.default.isDescending
    //   ? "descending"
    //   : "ascending";
    return "ascending";
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  private replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }

  @Watch("formats")
  onDocumentsUpdated(newValue: EditableFormatSummary[], oldValue: EditableFormatSummary[]): void {
    this.execSort();
  }

  @Watch("sortParameter")
  onSortParameterUpdated(newValue: ISortParameter, oldValue: ISortParameter): void {
    this.sortType = FormatSortSelector._columns[newValue.property] as IFormatsColumn;
    this.orderType = newValue.order;
  }

  @Watch("sortType")
  onSortTypeUpdated(newValue: IFormatsColumn, oldValue: IFormatsColumn): void {
    if (!oldValue || newValue.name !== oldValue.name) {
      this.execSort();
      this.updateSortParameter();
    }
  }

  @Watch("orderType")
  onOrderTypeUpdated(newValue: SortOrder, oldValue: SortOrder): void {
    if (newValue !== oldValue) {
      this.execSort();
      this.updateSortParameter();
    }
  }

  data(): any {
    return {
      sortType: null,
      orderType: null,
    };
  }
  sortType: IFormatsColumn;
  orderType: SortOrder;

  mounted(): void {
    this.initSortType();
  }

  initSortType(): void {
    if (this.isSortSettingEnable && this.settingSortType) {
      this.sortType = this.settingSortType;
      this.orderType = this.settingOrderType;
    } else {
      this.sortType = this.defaultSortType;
      this.orderType = this.defaultOrderType;
    }
  }

  execSort(): void {
    if (!this.formats || this.formats.length === 0 || !this.sortType || !this.orderType) {
      this.input([]);
      return;
    }

    const list = this.formats.slice();  // 複製して処理する
    this.sortList(list, this.sortType.toValue, this.orderType);
    this.editingSource = list;
  }

  sortList(list: EditableFormatSummary[], toValue: ToValueType, order: SortOrder): void {
    list.sort((a, b): number => {
      return Comparator.compare(toValue(a), toValue(b), order === "ascending");
    });
  }

  private updateSortParameter(): void {
    // keyを_columnsに定義した方が良い？
    const key = Enumerable.from(Object.keys(FormatSortSelector._columns))
      .firstOrDefault(k => FormatSortSelector._columns[k].name === this.sortType.name);
    const parameter: ISortParameter = {
      property: key,
      order: this.orderType,
    };
    this.$emit("update:sortParameter", parameter);
  }
}
